var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-heading"},[(!_vm.heading)?_c('SkeletonLoader',{staticClass:"h-[44px] s:h-[35px] m-0"}):_c('VaimoHeading',{attrs:{"heading":_vm.heading,"animated-heading":false,"heading-level":_vm.level}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }